import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";

const meses = [
  "Ene",
  "Feb",
  "Mar",
  "Abr",
  "May",
  "Jun",
  "Jul",
  "Ago",
  "Sep",
  "Oct",
  "Nov",
  "Dic"
];

// Función para obtener la segunda quincena de dos meses posteriores
const quincenaSuperior = (): Date => {
  const date = new Date();
  date.setMonth(date.getMonth() + 2);

  const month = date.getMonth();
  const year = date.getFullYear();

  return new Date(year, month + 1, 0);
};

// Generar 24 quincenas en orden descendente
const quincenaOpciones = (): Array<{ value: string; label: string }> => {
  const minDate = new Date(2026, 1, 15);
  const options: Array<{ value: string; label: string }> = [];
  let currentDate = quincenaSuperior();

  for (let i = 0; i < 24; i++) {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const day = currentDate.getDate();

    // Fecha mínima permitida: 15 de febrero de 2026
    if (currentDate >= minDate) {
      const value = `${year}-${String(month + 1).padStart(2, "0")}-${String(
        day
      ).padStart(2, "0")}`;
      const label = `${day} ${meses[month]} ${year}`;
      options.push({ value, label });
    }

    // Retroceder a la quincena anterior
    if (day === 15) {
      // Día 15 - Último día del mes pasado
      currentDate = new Date(year, month, 0);
    } else {
      // Último día del mes - Día 15 del mismo mes
      currentDate = new Date(year, month, 15);
    }
  }

  return options;
};

const quincenasOpts = quincenaOpciones();

export type Inputs = "fechaPago";
export type Buttons = "buscar";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "fechaPago",
      label: "* Fecha de pago",
      bts: { mCol: 4 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione",
        data: quincenasOpts
      }
    }
  ],
  buttons: [
    {
      name: "buscar",
      label: "Buscar",
      isSubmit: true,
      bts: { mCol: 3 },
      component: IButtonBuilder
    }
  ],
  validations: {
    fechaPago: {
      required: {
        validator: value => !value,
        message: () => "La quincena es requerida"
      }
    }
  },
  rows: [["fechaPago", "buscar"]]
};
